import React from "react";
import { Modal, PdfGenerator } from "../../../../../components";
import InvoiceHeader from "../../InvoicePdfComponents/InvoiceHeader";
import InvoiceContent from "../../InvoicePdfComponents/InvoiceContent";
import TableHeader from "../../../ComponentsList/List/PdfGeneratorList/Invoice/TableHeader";
import InvoiceFooter from "../../InvoicePdfComponents/InvoiceFooter";
import { useLoginUser } from "../../../../../hooks/useLoginUser";
import InvoiceData from "../../../ComponentsList/List/PdfGeneratorList/Invoice/InvoiceData";
const InvoiceViewModal = ({ isOpen, onClose, invoiceData }) => {
  const { userData: loginUserData } = useLoginUser();
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose(false)}
      closeOnOutsideClick={true}
      width="max-w-6xl"
      title="View Invoice"
    >
      {isOpen &&
        (() => {
          const invoiceObj = {
            company: {
              name: "TekTree LLC",
              address:
                [
                  invoiceData?.address?.from?.city,
                  invoiceData?.address?.from?.state,
                  invoiceData?.address?.from?.country,
                  invoiceData?.address?.from?.zipCode,
                ]
                  ?.filter(Boolean)
                  ?.join(", ") || "-",
              contact: "+1 (123) 456-7890",
              email: "accounts@tektreeinc.com",
              website: "www.tektreeinc.com",
              companyLogo: loginUserData?.organizationId?.logo?.company || "",
              backgroundLogo:
                loginUserData?.organizationId?.logo?.company || "",
              additionalInfo: invoiceData?.additionalInfo || "",
            },
            invoiceDeta: {
              amounts: {
                invoiced: invoiceData?.amounts?.invoiced || 0,
                due: invoiceData?.amounts?.due || 0,
              },
              name: invoiceData?.clientId?.businessName || "-",
              address:
                [
                  invoiceData?.address?.billing?.city,
                  invoiceData?.address?.billing?.state,
                  invoiceData?.address?.billing?.country,
                  invoiceData?.address?.billing?.zipCode,
                ]
                  ?.filter(Boolean)
                  ?.join(", ") || "-",
              invoiceNumber: invoiceData?.invoiceNum || "-",
              invoiceDate: invoiceData?.invoiceDate || "-",
              shippedDate: invoiceData?.shippedDate || "-",
              netTerms: invoiceData?.netTerms || "-",
              dueDate: invoiceData?.dueDate || "-",
              invoicedItems:
                invoiceData?.serviceSummary?.map((data) => ({
                  item: data?.activity || "-",
                  description: data?.ss || "-",
                  quantity: data?.quantity || 0,
                  price: data?.rate || 0,
                  discount: 0,
                })) || [],
            },
          };
          const subTotal = invoiceObj?.invoiceDeta?.invoicedItems.reduce(
            (sum, item) =>
              sum + (item.quantity * item.price - (item.discount || 0)),
            0,
          );
          const updatedData = {
            ...invoiceObj,
            invoiceDeta: {
              ...invoiceObj?.invoiceDeta,
              subTotal: subTotal,
              discountTotal:
                invoiceObj?.invoiceDeta?.amounts?.invoiced - subTotal || 0,
              invoiceTotal: invoiceObj?.invoiceDeta?.amounts?.invoiced || 0,
              dueTotal: invoiceObj?.invoiceDeta?.amounts?.due || 0,
              currency: "USD",
            },
          };
          return (
            <PdfGenerator
              data={updatedData}
              items={updatedData.invoiceDeta?.invoicedItems || []}
              header={<InvoiceHeader data={updatedData} />}
              headerTwo={<InvoiceHeader data={updatedData} type="sub" />}
              contentTop={<InvoiceContent data={updatedData} type="top" />}
              contentBottom={
                <InvoiceContent data={updatedData} type="bottom" />
              }
              tableHeader={<TableHeader />}
              rowRenderer={(item, index) => InvoiceData(item, index)}
              footer={<InvoiceFooter data={updatedData} />}
              footerTwo={<InvoiceFooter data={updatedData} type="sub" />}
              backgroundLogo={updatedData?.company?.backgroundLogo}
              fileName={`Invoice-${updatedData.invoiceDeta?.invoiceNumber || ""}`}
            />
          );
        })()}
    </Modal>
  );
};
export default InvoiceViewModal;
